<template>
    <div>
        <badger-accordion
            ref="accordion"
            :icons="{ opened: minusIcon, closed: plusIcon }"
            :options="badgerOptions"
        >
            <badger-accordion-item v-for="item in info" :key="item.id">
                <h3 slot="header" class="accordion-panel__title uppercase mb-1">
                    <span class="accordion-panel__underline">{{
                        item.title
                    }}</span>
                </h3>
                <div
                    slot="content"
                    class="mr-md-2 pb-1 pb-md-2 rte"
                    v-html="item.text"
                ></div>
            </badger-accordion-item>
        </badger-accordion>
    </div>
</template>

<script>
import { BadgerAccordion, BadgerAccordionItem } from 'vue-badger-accordion';

export default {
    components: {
        BadgerAccordion,
        BadgerAccordionItem
    },

    props: {
        info: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            minusIcon: '<i class="fas fa-minus"></i>',
            plusIcon: '<i class="fas fa-plus"></i>',
            badgerOptions: {
                openMultiplePanels: this.openMultiplePanels
            },
            windowWidth: null
        };
    },

    watch: {
        windowWidth(val) {
            this.badgerOptions.openMultiplePanels = val < 768;
            this.$refs.accordion.rerender();
        }
    },

    mounted() {
        this.$nextTick(() => {
            const self = this;
            let debouncetimer;

            window.addEventListener('resize', () => {
                clearTimeout(debouncetimer);
                debouncetimer = setTimeout(() => {
                    self.getWindowWidth();
                }, 100);
            });
        });
    },

    destroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    },

    methods: {
        getWindowWidth() {
            this.windowWidth = window.innerWidth;
        }
    }
};
</script>

<style lang="scss" scoped>
.accordion-panel__title {
    &:hover {
        cursor: pointer;

        span:after {
            opacity: 1;
        }
    }
}

.accordion-panel__underline {
    position: relative;

    &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 100%;
        height: 2px;
        opacity: 0;
        background-color: $color-black;
        transition: opacity 0.5s $easeOutQuad;

        .accordion-panel__title:hover & {
            opacity: 1;
        }
    }
}

.accordion-panel__toggle-wrap {
    display: block;
    position: relative;
    float: right;
    width: 16px;

    @include media-breakpoint-up(lg) {
        width: 18px;
    }
}

.accordion-panel__toggle {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transform: scale(0);
    transition: opacity 0.3s $easeOutQuad, transform 0.3s $easeOutQuad;

    &--active {
        transform: scaleY(1);
        opacity: 1;
    }
}
</style>
